import React, { useState } from 'react';
import locations from './locationsData';

const Catering = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    location: '',
    eventDate: '',
    eventTime: '',
    guestCount: '',
    eventType: '',
    dietaryRestrictions: '',
    budget: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission is handled by Netlify
  };

  return (
    <div className="catering-page" style={{
      maxWidth: '600px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{
        textAlign: 'center',
        color: '#333',
        marginBottom: '30px'
      }}>Catering Inquiry</h1>
      <form
        name="catering"
        method="POST"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px'
        }}
      >
        <input type="hidden" name="form-name" value="catering" />
        <p style={{ display: 'none' }}>
          <label>
            Don't fill this out if you're human: 
            <input name="bot-field" />
          </label>
        </p>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="location" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Preferred Location:</label>
          <select
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            required
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          >
            <option value="">Select a location</option>
            {locations.map((location, index) => (
              <option key={index} value={location.label}>
                {location.label} - {location.address?.[0]} {location.address?.[1]}
              </option>
            ))}
          </select>
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="name" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Contact Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="email" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="phone" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Phone Number:</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="eventDate" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Event Date:</label>
          <input
            type="date"
            id="eventDate"
            name="eventDate"
            value={formData.eventDate}
            onChange={handleChange}
            required
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="eventTime" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Event Time:</label>
          <input
            type="time"
            id="eventTime"
            name="eventTime"
            value={formData.eventTime}
            onChange={handleChange}
            required
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="guestCount" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Number of Guests:</label>
          <input
            type="number"
            id="guestCount"
            name="guestCount"
            value={formData.guestCount}
            onChange={handleChange}
            required
            min="1"
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="eventType" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Event Type:</label>
          <select
            id="eventType"
            name="eventType"
            value={formData.eventType}
            onChange={handleChange}
            required
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          >
            <option value="">Select event type</option>
            <option value="corporate">Corporate Event</option>
            <option value="wedding">Wedding</option>
            <option value="birthday">Birthday Party</option>
            <option value="graduation">Graduation</option>
            <option value="meeting">Business Meeting</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="budget" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Budget Range:</label>
          <select
            id="budget"
            name="budget"
            value={formData.budget}
            onChange={handleChange}
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          >
            <option value="">Select budget range</option>
            <option value="under-500">Under $500</option>
            <option value="500-1000">$500 - $1,000</option>
            <option value="1000-2000">$1,000 - $2,000</option>
            <option value="2000-5000">$2,000 - $5,000</option>
            <option value="over-5000">Over $5,000</option>
          </select>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="dietaryRestrictions" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Dietary Restrictions/Allergies:</label>
          <textarea
            id="dietaryRestrictions"
            name="dietaryRestrictions"
            rows="3"
            value={formData.dietaryRestrictions}
            onChange={handleChange}
            placeholder="Please list any dietary restrictions, allergies, or special requests..."
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px',
              resize: 'vertical'
            }}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="message" style={{
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#555'
          }}>Additional Details:</label>
          <textarea
            id="message"
            name="message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            placeholder="Please provide any additional details about your event, menu preferences, or special requests..."
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px',
              resize: 'vertical'
            }}
          />
        </div>

        <button type="submit" style={{
          padding: '12px 20px',
          backgroundColor: '#000000ff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          fontSize: '16px',
          cursor: 'pointer',
          transition: 'background-color 0.3s'
        }}>Submit Catering Inquiry</button>
      </form>
    </div>
  );
};

export default Catering;